import { useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  FormControl,
  FormLabel,
  Row,
} from "react-bootstrap";
import { Rating } from "@lomarengas/design-system";
import { MapPicker } from "../../components/MapPicker";
import { AccommodationDetailsBasic } from "./accommodationSlice";
import { getAccommodationTranslationItem } from "../../common/misc";
import { AddressResponse } from "../../features/identity/identitySlice";
import { useAuthUser } from "../../features/auth/authHooks";

const AccommodationBasic = ({
  accommodationDetailsBasic,
  accommodationAddress,
  handleKeyBoxSave,
  handleGeoCodeSave,
  errorInKeyBoxSave,
}: {
  accommodationDetailsBasic: AccommodationDetailsBasic;
  accommodationAddress: AddressResponse;
  handleKeyBoxSave: Function;
  handleGeoCodeSave: Function;
  errorInKeyBoxSave: boolean;
}) => {
  const { isOwnerUser } = useAuthUser();
  const [lat, setLat] = useState("");
  const [lng, setLng] = useState("");
  const [keyBox, setKeyBox] = useState("");
  const [originalKeyboxCode, setOriginalKeyboxCode] = useState("");

  const handleSelect = (lat, lng) => {
    setLat(lat);
    setLng(lng);
  };
  useEffect(() => {
    if (accommodationDetailsBasic != null) {
      setKeyBox(accommodationDetailsBasic.keyBox);
      setOriginalKeyboxCode(accommodationDetailsBasic.keyBox);
    }
  }, [accommodationDetailsBasic]);
  return (
    <>
      <Row xs={1} md={3}>
        <Col>
          <div className="border-bottom pb-16 mb-16">
            <FormLabel>Nimi</FormLabel>
            <div>
              {getAccommodationTranslationItem(
                "fi_FI",
                "AccommodationName",
                accommodationDetailsBasic,
              )}
            </div>
          </div>
        </Col>
        <Col>
          <div className="border-bottom pb-16 mb-16">
            <FormLabel>Varoaika</FormLabel>
            <div>{accommodationDetailsBasic.notOnSaleDays}</div>
          </div>
        </Col>
        <Col></Col>
      </Row>
      <Row xs={1} md={3}>
        <Col>
          <div className="border-bottom pb-16 mb-16">
            <FormLabel>Vuoteet</FormLabel>
            <div>{accommodationDetailsBasic.beds}</div>
          </div>
        </Col>
        <Col>
          <div className="border-bottom pb-16 mb-16">
            <FormLabel>Lisävuoteet</FormLabel>
            <div>{accommodationDetailsBasic.extraBeds}</div>
          </div>
        </Col>
        <Col>
          <div className="border-bottom pb-16 mb-16">
            <FormLabel>Tähtiluokka</FormLabel>
            <div className="d-flex gap-8">
              <Rating Rating={accommodationDetailsBasic.qualityRating}></Rating>{" "}
              ({accommodationDetailsBasic.qualityRating})
            </div>
          </div>
        </Col>
      </Row>
      <Row xs={1} md={3}>
        <Col>
          <div className="border-bottom pb-16 mb-16">
            <FormLabel>Osoite</FormLabel>
            <div>
              {accommodationAddress != null &&
                accommodationAddress.postStreetAddress}
              {accommodationAddress != null &&
                " " + accommodationAddress.additionalAddressLine}
            </div>
          </div>
        </Col>
        <Col>
          <div className="border-bottom pb-16 mb-16">
            <FormLabel>Postinumero</FormLabel>
            <div>
              {accommodationAddress != null && accommodationAddress.postCode}
            </div>
          </div>
        </Col>
        <Col>
          <div className="border-bottom pb-16 mb-16">
            <FormLabel>Postitoimipaikka</FormLabel>
            <div>
              {accommodationAddress != null && accommodationAddress.postCity}
            </div>
          </div>
        </Col>
      </Row>

      <Card className="mt-24">
        <Card.Body className="">
          {isOwnerUser && <p>Voit muokata sijaintia kartalla.</p>}
          <div className="ratio-ratio-16x9 bg-light">
            <MapPicker
              Zoom={10}
              Latitude={accommodationDetailsBasic.geoCode.latitude}
              Longitude={accommodationDetailsBasic.geoCode.longitude}
              HandleSelect={handleSelect}
              ReadOnlyMap={!isOwnerUser}
            />
          </div>
          <Row className="g-16 mt-8">
            <Col>
              <FormControl
                value={lat}
                disabled={!isOwnerUser}
                onChange={(e) => setLat(e.target.value)}
              ></FormControl>
            </Col>
            <Col>
              <FormControl
                value={lng}
                disabled={!isOwnerUser}
                onChange={(e) => setLng(e.target.value)}
              ></FormControl>
            </Col>
            <Col className="col-sm-auto 2 d-flex align-items-end">
              {isOwnerUser && (
                <Button
                  variant="primary"
                  className="w-100"
                  onClick={() => handleGeoCodeSave(lat, lng)}
                >
                  Tallenna
                </Button>
              )}
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Card className="mt-24">
        <Card.Body className="">
          <Row className="g-16">
            <Col>
              <FormLabel>
                Avainlaatikon koodi (alkuperäinen: {originalKeyboxCode} )
              </FormLabel>
              <FormControl
                disabled={errorInKeyBoxSave}
                value={errorInKeyBoxSave ? originalKeyboxCode : keyBox}
                onChange={(e) => setKeyBox(e.target.value)}
              ></FormControl>
            </Col>
            <Col className="col-sm-auto 2 d-flex align-items-end">
              <Button
                disabled={errorInKeyBoxSave}
                variant="primary"
                className="w-100"
                onClick={() => handleKeyBoxSave(keyBox)}
              >
                Tallenna
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </>
  );
};

export default AccommodationBasic;
export { AccommodationBasic };
